export const environment = {
  sispgUrlApi: 'https://api.app.unesp.br/sispg-api',
  sisespUrlApi: 'https://api.app.unesp.br/sisesp-api',
  sisespUrl: 'https://app.unesp.br/sisesp'
}
